/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SingleFormComponent as ɵc} from './single-form/single-form.component';
export {SingleComponent as ɵb} from './single.component';
export {declaration as ɵa} from './single.module';
export {SingleRoutes as ɵd} from './single.routing';